import React, { useEffect, useState, useRef, useCallback, use } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../context/AlertContext";
import jsPDF from "jspdf";
import InterRegular from "../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../sale/font/Inter_24pt-Bold-normal";
import { useAuth } from "../../../../context/AuthProvider";
import { useNetwork } from "../../../../context/NetworkContext";
import { usePermission } from "../../../../context/PermissionContext";
import { useContextApi } from "../../../../context/ContextApi";
import { FormatedTemplateData } from "../../../../templates/templateDataHandler";
import { getInvoiceConfig } from "../../../../templates/modules/getInvoiceConfig";
import RetailInvoice from "../../../../templates/halfa4/RetailInvoice";
import ClassicInvoice from "../../../../templates/halfa4/ClassicInvoice";
import CompactInvoice from "../../../../templates/halfa4/CompactInvoice";
import StandardReceipt from "../../../../templates/halfa4/StandardReceipt";
import PremiumInvoice from "../../../../templates/halfa4/PremiumInvoice";
import { parseAmount } from "../../../../templates/modules/invoiceUtils";
import CashButton from "../../sale/cashbtn";
import PayLaterButton from "../../sale/PaylaterBtn";
import handleError from "../../../../constants/handleError";
import { templateMap } from "../../../../templates/templateMap";
import { getOS } from "../../../../utils/getOs";
import NotoSansMonoReular from "../../sale/font/NotoSansMono-Regular-normal";
import NotoSansMonoBold from "../../sale/font/NotoSansMono-Bold-bold";
import HalfA4_1 from "./templates_halfA4/HalfA4_1";
import HalfA4_2 from "./templates_halfA4/HalfA4_2";
import HalfA4_3 from "./templates_halfA4/HalfA4_3";
import HalfA4_4 from "./templates_halfA4/HalfA4_4";
import { CheckIcon, ReceiptIcon, XIcon } from "../../../../constants/Icons";

const InvoiceHalfA4TempPreview = ({
  isData,
  onClose,
  onDataUpdate,
  onDataChange,
  onListSaleRefresh,
  onAdd,
  invoiceTheme = "INVPRO",
  termalTheme = "TMLBAS",
  halfA4Theme = "HA4RET",
  viewTheme,
}) => {
 
  const { settings } = useAuth();
  const showAlert = useShowAlert();
  const {storeSettings, viewOption } =
    usePermission();
  const os = getOS();
  const [billing, setBilling] = useState(false);
  const terms = storeSettings?.invoiceSettings?.termsAndConditions;
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [selectedOption, setSelectedOption] = useState(invoiceTheme);
  const [selectTermalOption, setSelectTermalOption] = useState(termalTheme);
  const [selectHalfA4Option, setSelectHalfA4Option] = useState(halfA4Theme);
  const [selectViewOption, setSelectedViewOption] = useState(viewTheme);
  const [selectedTheme, setSelectedTheme] = useState({
    key: "DF",
    templateTheme: {
      primaryColor: "#f4f4f6",
      secondaryColor: "#ffffff",
      foregroundColor: "#242c6d",
      backgroundColor: "#f4f4f6",
      borderColor: "#c9c9d1",
    },
  });
  const { useEscapeKey } = useContextApi();
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});  
  const [showConfirm, setShowConfirm] = useState(false);
  const cashRef = useRef();
  const paylaterRef = useRef();

  const globalData = FormatedTemplateData(data, storeSettings);
  const invoiceConfig = getInvoiceConfig(
    globalData,
    storeSettings,    
    settings,
  );
  const {
    isPreSale,
    showTaxDetails,
    isBillReceipt,
    isPurchase,
    isBill,
    documentConfig,
  } = invoiceConfig;
  const [selectedSize, setSelectedSize] = useState("HALFA4");

  const themes = [
    {
      key: "DF",
      label: "Default",
      templateTheme: {
        primaryColor: "#f4f4f6",
        secondaryColor: "#ffffff",
        foregroundColor: "#242c6d",
        backgroundColor: "#f4f4f6",
        borderColor: "#c9c9d1",
      },
    },
    {
      key: "DDF",
      label: "Darkindigo",
      templateTheme: {
        primaryColor: "#242c6d",
        secondaryColor: "#f4f4f6",
        foregroundColor: "#ffffff",
        backgroundColor: "#f4f4f6",
        borderColor: "#c9c9d1",
      },
    },
    {
      key: "BW",
      label: "Black & White",
      templateTheme: {
        primaryColor: "#000000",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#000000",
        borderColor: "#d1d1d1",
      },
    },
    {
      key: "PDW",
      label: "DarkPurple & white",
      templateTheme: {
        primaryColor: "#ffa726",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#F5E8FF",
        borderColor: "#ffe0b2",
      },
    },
    {
      key: "IW",
      label: "Indigo & White",
      templateTheme: {
        primaryColor: "#3f51b5",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#F3F4FF",
        borderColor: "#C7CCF0",
      },
    },
    {
      key: "PP",
      label: "Pink & White",
      templateTheme: {
        primaryColor: "#ec407a",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#FCE7F3",
        borderColor: "#F2A7C9",
      },
    },
    {
      key: "DPW",
      label: "DarkPurple & White",
      templateTheme: {
        primaryColor: "#932b68",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#F8E6F2",
        borderColor: "#D8A6C5",
      },
    },
    {
      key: "PB",
      label: "Peach & Black",
      templateTheme: {
        primaryColor: "#E5AA8D",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#FFF4EF",
        borderColor: "#EBCABC",
      },
    },
    {
      key: "GW",
      label: "Green & White",
      templateTheme: {
        primaryColor: "#2BA37A",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#2BA37A",
        borderColor: "#89c5b1",
      },
    },
    {
      key: "PW",
      label: "Purple & White",
      templateTheme: {
        primaryColor: "#6B3FA0",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#6B3FA0",
        borderColor: "#ab8cd1",
      },
    },
    {
      key: "GDW",
      label: "DarkGreen & White",
      templateTheme: {
        primaryColor: "#0F7554",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#0F7554",
        borderColor: "#45a787",
      },
    },
    {
      key: "YW",
      label: "Yellow & White",
      templateTheme: {
        primaryColor: "#ffeb3b",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#212121",
        backgroundColor: "#fff9c4",
        borderColor: "#fff59d",
      },
    },
    {
      key: "BGW",
      label: "BuleGray & White",
      templateTheme: {
        primaryColor: "#263238",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#fff9c4",
        borderColor: "#b0bec5",
      },
    },
    {
      key: "BW",
      label: "Blue & White",
      templateTheme: {
        primaryColor: "#0277bd",
        secondaryColor: "#FFFFFF",
        foregroundColor: "#FFFFFF",
        backgroundColor: "#fff9c4",
        borderColor: "#4fc3f7",
      },
    },
  ];
  const handleRadioChange = async (option, color) => {
    setSelectHalfA4Option(option);
    setSelectedViewOption(option);
    console.log("inradio");
    // await handleSetTemplate(option, color);
  };

  const handleRadioTermal = (option, color) => {
    setSelectTermalOption(option);
    setSelectedViewOption(option);
    console.log("terradio");
  };

  const handleClose = () => {
    setIsMainModalOpen(false);
    onClose();
  };
  useEscapeKey(handleClose);

  const handleSelectTemp = () => {
    onAdd(
      selectedOption,
      selectTermalOption,
      selectHalfA4Option,
      selectedTheme?.templateTheme,
    );
  };

  const [scale, setScale] = useState(1);
  const wrapperRef = useRef(null);
  const invoiceRef = useRef(null);

  useEffect(() => {
    const updateScale = () => {
      if (wrapperRef.current && invoiceRef.current) {
        const wrapperHeight = wrapperRef.current.offsetHeight;
        const invoiceHeight = invoiceRef.current.offsetHeight;

        const newScale = wrapperHeight / invoiceHeight;
        setScale(newScale);
      }
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);
  
  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal",
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS(
          "NotoSansMono_24pt-Regular-normal.ttf",
          NotoSansMonoReular,
        );
        this.addFileToVFS(
          "NotoSansMono_24pt-Bold-normal.ttf",
          NotoSansMonoBold,
        );
        this.addFont(
          "NotoSansMono_24pt-Regular-normal.ttf",
          "NotoSansMono-Regular",
          "normal",
        );
        this.addFont(
          "NotoSansMono_24pt-Bold-normal.ttf",
          "NotoSansMono-Bold",
          "bold",
        );
      },
    ]);
  }, []);

  useEffect(() => {
    if (storeSettings.invoiceSettings?.template?.templateTheme) {
      setSelectedTheme(storeSettings.invoiceSettings?.template);
    }
    setSelectedOption(invoiceTheme);
    setSelectTermalOption(termalTheme);
    setSelectHalfA4Option(halfA4Theme);
    setSelectedViewOption(viewTheme);
  }, []);

  const handleModeConfirm = () => {
    setShowConfirm(true);
  };
  const handleDownload = async (data) => {
    setDownload(true);
    try {
      const printData = globalData;
      const printInvoiceConfig = invoiceConfig;
      const salemode = printInvoiceConfig?.documentConfig?.title || "Document";
      const saleno = printInvoiceConfig?.documentConfig?.number || "Document";
      let generator;
      let generatorType;
      if (isPreSale) {
        generatorType = showTaxDetails ? "invoice" : "bill";
      } else {
        generatorType = isBill && !isBillReceipt ? "bill" : "invoice";
      }
      if (selectedSize === "A4") {
        const template = templateMap.A4?.[selectedOption];

        if (!template) {
          showAlert("warning", "Please select an A4 template.");
          return;
        }
        generator = template?.[generatorType] ?? template?.print;
      } else if (selectedSize === "HALFA4") {
        const template = templateMap.HALFA4?.[selectHalfA4Option];

        if (!template) {
          showAlert("warning", "Please select a Half A4 template.");
          return;
        }

        generator = template?.[generatorType] ?? template?.print;
      } else {
        const template = templateMap.TERMINAL?.[selectTermalOption];

        if (!template?.generator?.[selectedSize]) {
          showAlert("warning", "Please select a Thermal template.");
          return;
        }

        const thermalType = template.generator[selectedSize];
        generator = thermalType?.[generatorType];
      }

      if (!generator) {
        showAlert("warning", "PDF generator not found.");
        return;
      }

      // 3. Generate and save PDF
      const doc = await generator(
        printData,
        qrCodeDataUrl,
        terms,
        printInvoiceConfig,
        selectedTheme,        
        storeSettings,
      );

      if (!doc) {
        showAlert("warning", "Unable to generate PDF.");
        return;
      }

      const filenamePrefix = (salemode || "TAX_INVOICE").replace(/\s+/g, "_");

      doc.save(`${filenamePrefix}_${saleno}.pdf`);
    } catch (error) {
      console.error("Download Error:", error);
      showAlert("error", "Failed to download PDF.");
    } finally {
      setDownload(false);
    }
  };

  const handlePrintService = async (pdfBase64, printerName) => {
    try {
      const response = await axios.post(
        "http://127.0.0.1:9164/print/pdf",
        {
          pdfBase64,
          printerName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handlePrintSystem = async (pdfBase64, printerName) => {
    if (
      os === "Windows" &&
      storeSettings?.printSystemSettings?.printThrough &&
      printerName
    ) {
      return await handlePrintService(pdfBase64, printerName);
    } else {
      setBilling(false);
    }
    return false;
  };

  const handlePrint = async () => {
    if (print) return;

    setPrint(true);
    try {
      let generator;
      if (isPurchase) {
        generator = templateMap.A4.PURCHASE?.print;
      } else {
        let generatorType;

        if (isPreSale) {
          generatorType = showTaxDetails ? "invoice" : "bill";
        } else {
          generatorType = isBill && !isBillReceipt ? "bill" : "invoice";
        }

        if (selectedSize === "A4") {
          const template = templateMap.A4[selectedOption];
          generator = template?.[generatorType] ?? template?.print;
        } else if (selectedSize === "HALFA4") {
          const template = templateMap.HALFA4[selectHalfA4Option];
          generator = template?.[generatorType] ?? template?.print;
        } else {
          const template = templateMap.TERMINAL[selectTermalOption];
          const printer = storeSettings?.printSystemSettings?.printThrough
            ? template.generator[selectedSize]
            : template.browser[selectedSize];

          generator = printer?.[generatorType];
        }
      }
      const printData = globalData;

      const printInvoiceConfig = invoiceConfig;
      const doc = await generator(
        printData,
        qrCodeDataUrl,
        terms,
        printInvoiceConfig,
        selectedTheme,        
        storeSettings,
      );
      const pdfBase64 = doc.output("datauristring").split(",")[1];
      const response = await handlePrintSystem(
        pdfBase64,
        storeSettings?.printSystemSettings?.printerName,
      );
      if (storeSettings?.printSystemSettings?.printThrough && response) {
        return;
      }
      await handleSelectTemp();
      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          if (!mql.matches) {
            setTimeout(cleanup, 50);
          }
        };

        printWindow.matchMedia("(print)").addListener(handlePrintState);
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle"),
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
    } finally {
      setPrint(false);
    }
  };
  
  useEffect(() => {
    setSelectedSize("HALFA4");
  }, []);

  useEffect(() => {
    setData(isData);
  }, [isData]);

  return (
    <>
      {isMainModalOpen && (
        <div>
          <div className="modal-backdrop show"></div>
          <div
            className="modal show"
            id="CustomerModal"
            tabIndex="-1"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-scrollable modal-xlg2">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="d-flex align-items-center">
                    <h6 className="modal-title mb-0">
                      Template -{" "}
                      {selectHalfA4Option === "HA4RET" && "Retail Invoice"}
                      {selectHalfA4Option === "HA4SRT" && "Standard Receipt"}
                      {selectHalfA4Option === "HA4CMP" && "Compact Invoice"}
                      {selectHalfA4Option === "HA4CLS" && "Classic Invoice"}
                      {selectHalfA4Option === "HA4PRM" && "Premium Invoice"}
                    </h6>
                    {viewOption("saleModeSettings", "isInvoice") &&
                      data.salemode === "BILL" &&
                      data.status === "ACTIVE" &&
                      (isBtnLoading ? (
                        <button
                          className="btn bg-label-network pb-0 text-right ms-3"
                          disabled
                        >
                          <CircularProgress size={22} className="text-white" />
                        </button>
                      ) : (
                        <button
                          className="btn bg-label-network shadow-none text-right ms-3"
                          onClick={handleModeConfirm}
                        >
                          <ReceiptIcon/> Convert To Invoice
                        </button>
                      ))}
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <p className="mb-0 ">Sample Invoice</p>

                    <button
                      type="button"
                      onClick={handleClose}
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                </div>
                <div
                  className="modal-body p-0 d-flex"                
                  // style={{ height: "80vh", overflow: "hidden" }}
                  id="element-to-download"
                >
                  <div
                    className="border-end"
                    style={{
                      width: "82px",
                      flex: "0 0 82px",
                      overflowY: "auto",
                    }}
                  >
                    <div>
                      <span className="px-2 breadcrumb-title">Colors</span>

                      <div className="theme-grid p-2">
                        {themes.map((opt) => (
                          <button
                            key={opt.key}
                            type="button"
                            className={`theme-btn d-flex justify-content-center ${
                              selectedTheme?.templateTheme?.primaryColor ===
                              opt.templateTheme?.primaryColor
                                ? "active"
                                : ""
                            }`}
                            style={{
                              "--b-color": opt.templateTheme?.primaryColor,
                            }}
                            onClick={() => {
                              setSelectedTheme(opt);
                            }}
                          >
                            <span
                              className="theme-square"
                              style={{
                                backgroundColor:
                                  opt.templateTheme?.primaryColor,
                              }}
                            />
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div
                    className="px-3 py-1 hide-scrollbar flex-grow-1 w-100"
                    style={{
                      overflowY: "auto",
                      maxHeight: "100%",
                    }}
                  >
                    {/* <div className="" > */}
                    <div className="">
                      {selectHalfA4Option === "HA4RET" && (
                        <RetailInvoice
                          data={globalData}
                          selectedTheme={selectedTheme}
                          invoiceConfig={invoiceConfig}
                        />
                      )}
                      {selectHalfA4Option === "HA4SRT" && (
                        <StandardReceipt
                          data={globalData}
                          selectedTheme={selectedTheme}
                          invoiceConfig={invoiceConfig}
                        />
                        // <HalfA4_2
                        //   isViewData={data}
                        //   selectedTheme={selectedTheme}
                        //   selectedSize={selectedSize}
                        //   downloadbtn={true}
                        //   payment={true}
                        // />
                      )}
                      {selectHalfA4Option === "HA4CMP" && (
                        <CompactInvoice
                          data={globalData}
                          selectedTheme={selectedTheme}
                          invoiceConfig={invoiceConfig}
                        />
                      )}
                      {selectHalfA4Option === "HA4CLS" && (
                        <ClassicInvoice
                          data={globalData}
                          selectedTheme={selectedTheme}
                          invoiceConfig={invoiceConfig}
                        />
                      )}
                      {selectHalfA4Option === "HA4PRM" && (
                        <PremiumInvoice
                          data={globalData}
                          selectedTheme={selectedTheme}
                          invoiceConfig={invoiceConfig}
                        />
                      )}
                      <div
                        className="modal-footer d-block mt-2"
                        style={{
                          position: "sticky",
                          bottom: 0,
                          background: "#fff",
                          zIndex: 10,
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        <div className="fw-600 mb-2">PAYMENT SUMMARY</div>
                        <table
                          className="items table-bordered mb-3"
                          width="100%"
                          cellPadding="8"
                        >
                          <tbody className="text-center">
                            <tr>
                              <th
                                style={{
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                  cursor:
                                    parseAmount(documentConfig?.cashPaid) > 0
                                      ? "pointer"
                                      : "default",
                                  padding: "6px 12px",
                                }}
                                onClick={(e) => {
                                  if (
                                    parseAmount(documentConfig?.cashPaid) > 0
                                  ) {
                                    cashRef.current.openPopover(e);
                                  }
                                }}
                              >
                                <div
                                  className={
                                    parseAmount(documentConfig?.cashPaid) > 0
                                      ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                                      : "d-inline-flex align-items-center"
                                  }
                                  style={{ gap: "4px" }}
                                >
                                  CASH
                                  {parseAmount(documentConfig?.cashPaid) >
                                    0 && <i className="bx bx-show" />}
                                </div>
                              </th>
                              <th
                                style={{
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                CARD
                              </th>
                              <th
                                style={{
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                ONLINE
                              </th>
                              <th
                                style={{
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                UPI
                              </th>
                              <th
                                style={{
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                  cursor:
                                    Math.abs(
                                      parseAmount(documentConfig?.balanceDue),
                                    ) > 0
                                      ? "pointer"
                                      : "default",
                                  padding: "6px 12px",
                                }}
                                onClick={(e) => {
                                  if (
                                    Math.abs(
                                      parseAmount(documentConfig?.balanceDue),
                                    ) > 0
                                  ) {
                                    paylaterRef.current.openPopover(e);
                                  }
                                }}
                              >
                                <div
                                  className={
                                    Math.abs(
                                      parseAmount(documentConfig?.balanceDue),
                                    ) >
                                    0 >
                                    0
                                      ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                                      : "d-inline-flex align-items-center"
                                  }
                                  style={{ gap: "4px" }}
                                >
                                  PAYLATER
                                  {Math.abs(
                                    parseAmount(documentConfig?.balanceDue),
                                  ) > 0 && <i className="bx bx-show ms-1" />}
                                </div>
                              </th>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                                className="text-center"
                              >
                                {documentConfig?.cashPaid}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                                className="text-center"
                              >
                                {documentConfig?.cardPaid}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                                className="text-center"
                              >
                                {documentConfig?.onlinePaid}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                                className="text-center"
                              >
                                {documentConfig?.upiPaid}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                                className="text-center"
                              >
                                {documentConfig?.balanceDue}
                                {/* {isViewData.paylateramount > 0 &&
                                                isViewData.status === "ACTIVE" && (
                                                  <button
                                                    className="btn btn-sm bg-label-anime ms-2 px-2"
                                                    onClick={handlePaySettleOpen}
                                                  >
                                                    <i className="bx bx-plus"></i>Settle
                                                  </button>
                                                )} */}
                              </td>
                            </tr>
                          </tbody>
                          <CashButton
                            ref={cashRef}
                            trackId={data?.boxCashInfo?.trackid}
                            trackMode={data?.boxCashInfo?.trackmode}
                          />
                          <PayLaterButton
                            ref={paylaterRef}
                            trackId={data?.paylaterInfo?.trackid}
                            customerId={data?.paylaterInfo?.customerid}
                            trackMode={data?.paylaterInfo?.trackmode}
                          />
                        </table>

                        <div className="my-2 d-flex gap-2">
                          <div className="btn-group text-right align-items-center">
                            {print ? (
                              <button
                                className="btn bg-label-animal btn-sm pb-0"
                                disabled
                              >
                                <CircularProgress
                                  size={18}
                                  className="text-white"
                                />
                              </button>
                            ) : (
                              <>
                                <button
                                  onClick={handlePrint}
                                  className="btn bg-label-animal shadow-none btn-sm "
                                  id="printreceiptbtn"
                                >
                                  <i className="bx bx-printer fs-15"></i> Print{" "}
                                  {selectedSize}
                                </button>
                              </>
                            )}
                          </div>

                          {download ? (
                            <button
                              className="btn btn-warning btn-sm pb-0 text-right"
                              disabled
                            >
                              <CircularProgress
                                size={18}
                                className="text-black"
                              />
                            </button>
                          ) : (
                            <button
                              className="btn btn-warning btn-sm text-right"
                              id="generatebillpdfbtn"
                              onClick={() => handleDownload(globalData)}
                            >
                              <i className="bx bx-download fs-15"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="border-start"
                    style={{
                      width: "262px",
                      flex: "0 0 262px",
                      overflowY: "auto",
                    }}
                  >
                    <div>
                      <span className="px-2 breadcrumb-title">Templates</span>
                      <div className="invoice-thumbnailModel-grid mt-2 p-1">
                        <div
                          className={`invoiceHalfA4-thumbnailModel position-relative form-check custom-option custom-option-image custom-option-image-check
              ${
                selectHalfA4Option === "HA4RET" ? "active" : ""
              } ms-2 mb-1 cursor-poInter`}
                          onClick={() =>
                            handleRadioChange(
                              "HA4RET",
                              selectedTheme?.templateTheme,
                            )
                          }
                        >
                          <div className="template-label">Retail Invoice</div>
                          <div
                            className="invoice-scale"
                            for={"HA4RET"}
                            onClick={() => {
                              setSelectHalfA4Option("HA4RET");
                              setSelectedViewOption("HA4RET");
                            }}
                          >
                            <RetailInvoice
                              data={globalData}
                              selectedTheme={selectedTheme}
                              invoiceConfig={invoiceConfig}
                            />
                          </div>
                        </div>
                        <div
                          className={`invoiceHalfA4-thumbnailModel position-relative form-check custom-option custom-option-image custom-option-image-check
              ${
                selectHalfA4Option === "HA4SRT" ? "active" : ""
              } ms-2 mb-1 cursor-poInter`}
                          onClick={() =>
                            handleRadioChange(
                              "HA4SRT",
                              selectedTheme?.templateTheme,
                            )
                          }
                        >
                          <div className="template-label">Standard Receipt</div>
                          <div
                            className="invoice-scale"
                            for={"HA4SRT"}
                            onClick={() => {
                              setSelectHalfA4Option("HA4SRT");
                              setSelectedViewOption("HA4SRT");
                            }}
                          >
                            <StandardReceipt
                              data={globalData}
                              selectedTheme={selectedTheme}
                              invoiceConfig={invoiceConfig}
                            />
                          </div>
                        </div>
                        <div
                          className={`invoiceHalfA4-thumbnailModel position-relative form-check custom-option custom-option-image custom-option-image-check
              ${
                selectHalfA4Option === "HA4CMP" ? "active" : ""
              } ms-2 mb-1 cursor-poInter`}
                          onClick={() =>
                            handleRadioChange(
                              "HA4CMP",
                              selectedTheme?.templateTheme,
                            )
                          }
                        >
                          <div className="template-label">Compact Invoice</div>
                          <div
                            className="invoice-scale"
                            for={"HA4CMP"}
                            onClick={() => {
                              setSelectHalfA4Option("HA4CMP");
                              setSelectedViewOption("HA4CMP");
                            }}
                          >
                            <CompactInvoice
                              data={globalData}
                              selectedTheme={selectedTheme}
                              invoiceConfig={invoiceConfig}
                            />
                          </div>
                        </div>

                        <div
                          className={`invoiceHalfA4-thumbnailModel position-relative form-check custom-option custom-option-image custom-option-image-check
              ${
                selectHalfA4Option === "HA4CLS" ? "active" : ""
              } ms-2 mb-1 cursor-poInter`}
                          onClick={() =>
                            handleRadioChange(
                              "HA4CLS",
                              selectedTheme?.templateTheme,
                            )
                          }
                        >
                          <div className="template-label">Classic Invoice</div>
                          <div
                            className="invoice-scale"
                            for={"HA4CLS"}
                            onClick={() => {
                              setSelectHalfA4Option("HA4CLS");
                              setSelectedViewOption("HA4CLS");
                            }}
                          >
                            <ClassicInvoice
                              data={globalData}
                              selectedTheme={selectedTheme}
                              invoiceConfig={invoiceConfig}
                            />
                          </div>
                        </div>

                        <div
                          className={`invoiceHalfA4-thumbnailModel position-relative form-check custom-option custom-option-image custom-option-image-check
              ${
                selectHalfA4Option === "HA4PRM" ? "active" : ""
              } ms-2 mb-1 cursor-poInter`}
                          onClick={() =>
                            handleRadioChange(
                              "HA4PRM",
                              selectedTheme?.templateTheme,
                            )
                          }
                        >
                          <div className="template-label">Premium Invoice</div>
                          <div
                            className="invoice-scale"
                            for={"HA4PRM"}
                            onClick={() => {
                              setSelectHalfA4Option("HA4PRM");
                              setSelectedViewOption("HA4PRM");
                            }}
                          >
                            <PremiumInvoice
                              data={globalData}
                              selectedTheme={selectedTheme}
                              invoiceConfig={invoiceConfig}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer d-block">
                  <button
                    onClick={handleClose}
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-outline-secondary text-start"
                  >
                    <XIcon iClass={"fs-15"}/> Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary text-right "
                    onClick={handleSelectTemp}
                  >
                    <CheckIcon/>Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceHalfA4TempPreview;
